import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bsx_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', null, { params: data }),
};

// Securities API
export const securitiesAPI = {
  getAll: (params) => api.get('/securities', { params }),
  getMovies: (params) => api.get('/securities/movies', { params }),
  getStars: (params) => api.get('/securities/stars', { params }),
  getHot: (limit = 10) => api.get('/securities/hot', { params: { limit } }),
  getOpening: (limit = 6) => api.get('/securities/opening', { params: { limit } }),
  getIPO: () => api.get('/securities/ipo'),
  getBySymbol: (symbol) => api.get(`/securities/${symbol}`),
  getHistory: (symbol, days = 30) => api.get(`/securities/${symbol}/history`, { params: { days } }),
};

// Trading API
export const tradingAPI = {
  buy: (data) => api.post('/trading/buy', data),
  sell: (data) => api.post('/trading/sell', data),
  short: (data) => api.post('/trading/short', data),
  cover: (data) => api.post('/trading/cover', data),
  executeTrade: (data) => api.post('/trading/trade', data),
  getPortfolio: () => api.get('/trading/portfolio'),
  getMyTrades: (limit = 50) => api.get('/trading/history', { params: { limit } }),
  getHistory: (limit = 50) => api.get('/trading/history', { params: { limit } }),
  getRecentTrades: (limit = 20) => api.get('/trading/recent', { params: { limit } }),
};

// Forum API
export const forumAPI = {
  getCategories: () => api.get('/forum/categories'),
  getPosts: (params) => api.get('/forum/posts', { params }),
  getPost: (postId) => api.get(`/forum/posts/${postId}`),
  createPost: (data) => api.post('/forum/posts', data),
  createReply: (postId, data) => api.post(`/forum/posts/${postId}/reply`, data),
  replyToPost: (postId, data) => api.post(`/forum/posts/${postId}/reply`, data),
  likePost: (postId) => api.post(`/forum/posts/${postId}/like`),
};

// Leaderboard API
export const leaderboardAPI = {
  get: (params) => api.get('/leaderboard', { params }),
  getUserRank: (username) => api.get(`/leaderboard/user/${username}`),
};

// Users API
export const usersAPI = {
  getProfile: (username) => api.get(`/users/${username}`),
  getPortfolio: (username) => api.get(`/users/${username}/portfolio`),
};

// News API
export const newsAPI = {
  getAll: (params) => api.get('/news', { params }),
  get: (articleId) => api.get(`/news/${articleId}`),
};

// Stats API
export const statsAPI = {
  get: () => api.get('/stats'),
};

export default api;
